export default function translate(i18n, propriete) {
  if (propriete === 'indexationInput.DateIndexation') return i18n.t('detailCommande.indexation.popUp.dateIndexation');
  if (propriete === 'indexationInput.ValeurIndexationActuel') return i18n.t('detailCommande.indexation.popUp.valeurIndexationActuel');
  if (propriete === 'indexationInput.DateIndexationActuel') return i18n.t('detailCommande.indexation.popUp.dateIndexationActuel');
  if (propriete === 'indexationInput.PourcentageReel') return i18n.t('detailCommande.indexation.popUp.pourcentageReel');
  if (propriete === 'indexationInput.TypesProduits') return i18n.t('detailCommande.indexation.popUp.typesProduits');
  if (propriete === 'indexationInput.ValeurIndexationReference') return i18n.t('detailCommande.indexation.popUp.valeurIndexationReference');
  return propriete;
}
